(function (window, document) {
  const variable = '--full-viewport';
  let lastWidth = window.innerWidth;

  function vh() {
    const currentWidth = window.innerWidth;

    if (currentWidth !== lastWidth) {
      document.documentElement.style.setProperty(variable, `${window.innerHeight}px`);
      lastWidth = currentWidth;
    }
  }

  document.documentElement.style.setProperty(variable, `${window.innerHeight}px`);

  window.addEventListener('resize', vh);
})(window, document);